/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { NewWorkflowStepFunctionSubscribedEvent } from '../models/new-workflow-step-function-subscribed-event';
import { WorkflowStepFunctionSubscribedEvent } from '../models/workflow-step-function-subscribed-event';
import { WorkflowStepFunctionSubscribedEventPartial } from '../models/workflow-step-function-subscribed-event-partial';
import { WorkflowStepFunctionSubscribedEventWithRelations } from '../models/workflow-step-function-subscribed-event-with-relations';
import { Count as LoopbackCount } from '../models/loopback/count';

@Injectable({
  providedIn: 'root',
})
export class WorkflowStepFunctionSubscribedEventControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation workflowStepFunctionSubscribedEventControllerCount
   */
  static readonly WorkflowStepFunctionSubscribedEventControllerCountPath = '/workflow-step-function-subscribed-events/count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `count()` instead.
   *
   * This method doesn't expect any request body.
   */
  count$Response(params?: {
    where?: any;
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowStepFunctionSubscribedEventControllerService.WorkflowStepFunctionSubscribedEventControllerCountPath, 'get');
    if (params) {
      rb.query('where', params.where, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `count$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  count(params?: {
    where?: any;
  }): Observable<LoopbackCount> {

    return this.count$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation workflowStepFunctionSubscribedEventControllerFindById
   */
  static readonly WorkflowStepFunctionSubscribedEventControllerFindByIdPath = '/workflow-step-function-subscribed-events/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    id: string;
    filter?: any;
  }): Observable<StrictHttpResponse<WorkflowStepFunctionSubscribedEvent>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowStepFunctionSubscribedEventControllerService.WorkflowStepFunctionSubscribedEventControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkflowStepFunctionSubscribedEvent>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    id: string;
    filter?: any;
  }): Observable<WorkflowStepFunctionSubscribedEvent> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<WorkflowStepFunctionSubscribedEvent>) => r.body as WorkflowStepFunctionSubscribedEvent)
    );
  }

  /**
   * Path part for operation workflowStepFunctionSubscribedEventControllerDeleteById
   */
  static readonly WorkflowStepFunctionSubscribedEventControllerDeleteByIdPath = '/workflow-step-function-subscribed-events/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowStepFunctionSubscribedEventControllerService.WorkflowStepFunctionSubscribedEventControllerDeleteByIdPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById(params: {
    id: string;
  }): Observable<any> {

    return this.deleteById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation workflowStepFunctionSubscribedEventControllerUpdateById
   */
  static readonly WorkflowStepFunctionSubscribedEventControllerUpdateByIdPath = '/workflow-step-function-subscribed-events/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById$Response(params: {
    id: string;
    body?: WorkflowStepFunctionSubscribedEventPartial
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowStepFunctionSubscribedEventControllerService.WorkflowStepFunctionSubscribedEventControllerUpdateByIdPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById(params: {
    id: string;
    body?: WorkflowStepFunctionSubscribedEventPartial
  }): Observable<any> {

    return this.updateById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation workflowStepFunctionSubscribedEventControllerFind
   */
  static readonly WorkflowStepFunctionSubscribedEventControllerFindPath = '/workflow-step-function-subscribed-events';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params?: {
    filter?: any;
  }): Observable<StrictHttpResponse<Array<WorkflowStepFunctionSubscribedEventWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowStepFunctionSubscribedEventControllerService.WorkflowStepFunctionSubscribedEventControllerFindPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkflowStepFunctionSubscribedEventWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params?: {
    filter?: any;
  }): Observable<Array<WorkflowStepFunctionSubscribedEventWithRelations>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<WorkflowStepFunctionSubscribedEventWithRelations>>) => r.body as Array<WorkflowStepFunctionSubscribedEventWithRelations>)
    );
  }

  /**
   * Path part for operation workflowStepFunctionSubscribedEventControllerCreate
   */
  static readonly WorkflowStepFunctionSubscribedEventControllerCreatePath = '/workflow-step-function-subscribed-events';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params?: {
    body?: NewWorkflowStepFunctionSubscribedEvent
  }): Observable<StrictHttpResponse<WorkflowStepFunctionSubscribedEvent>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowStepFunctionSubscribedEventControllerService.WorkflowStepFunctionSubscribedEventControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkflowStepFunctionSubscribedEvent>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params?: {
    body?: NewWorkflowStepFunctionSubscribedEvent
  }): Observable<WorkflowStepFunctionSubscribedEvent> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<WorkflowStepFunctionSubscribedEvent>) => r.body as WorkflowStepFunctionSubscribedEvent)
    );
  }

}
